import(/* webpackMode: "eager", webpackExports: ["SimulatePreloadedQuery"] */ "/opt/build/repo/node_modules/@apollo/client-react-streaming/dist/index.cc.js");
;
import(/* webpackMode: "eager", webpackExports: ["BlogItems"] */ "/opt/build/repo/src/app/components/Blog/BlogItems.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BlogPostFeatured"] */ "/opt/build/repo/src/app/components/Blog/BlogPostFeatured.tsx");
